import { skipToken } from '@reduxjs/toolkit/query/react';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useView } from './useView';

import type { Document } from '@/types';

import { useGetDocumentQuery } from '@/store/api/documentApi';

export const useDocument = (isTemplate: boolean, id?: string) => {
  const navigate = useNavigate();
  const { documentId = '', templateId = '' } = useParams();
  const { selectedUserId } = useView();
  const idToUse = id || (isTemplate ? templateId : documentId);

  const {
    data: currentDocument = {} as Document,
    isLoading: isDocumentLoading,
    refetch: refetchDocument,
  } = useGetDocumentQuery(idToUse || skipToken);

  useEffect(() => {
    if (Object.keys(currentDocument).length > 0 && !currentDocument.id) {
      let path = '/documents';
      if (selectedUserId) {
        path = `/members/${selectedUserId}/documents`;
      }
      navigate(path);
    }
  }, [currentDocument, selectedUserId, navigate]);

  return { currentDocument, isDocumentLoading, refetchDocument };
};
